// @flow
import { configValue } from 'utils/config';

const getPostSearchIndex = () => configValue('algolia', 'contentIndexName');

export default getPostSearchIndex;
